@if (isVerificationMode() && isLoadingConversation() && !displayMessages().length) {
  <div class="welcome-block">
    <div class="message-bubble welcome-bubble">
      <div class="message-text">Loading conversation…</div>
    </div>
  </div>
} @else if (!displayMessages().length && !isSending() && !pendingUserMessage()) {
  @if (sendErrorMessage(); as errMsg) {
    <ng-container *ngTemplateOutlet="assistantBubble; context: { bubbleClass: 'message-bubble-error', bodyTemplate: errorBubbleBody, bodyContext: { errMsg } }"></ng-container>
  } @else {
    <div class="welcome-block">
      <div class="message-meta">
        <app-parent-ai-assistant-meta-row />
      </div>
      <div class="message-group">
        <div class="message-bubble welcome-bubble">
          <div class="message-text">
            {{ 'app.components.parentAiAssistant.welcomeHi' | translate:{ name: userDisplayName() } }}
            @if (selectedChild(); as child) {
              {{ 'app.components.parentAiAssistant.welcomeWithChild' | translate:{ name: child.name } }}
            } @else {
              {{ 'app.components.parentAiAssistant.welcomeDefault' | translate }}
            }
          </div>
        </div>
      </div>
    </div>
  }
} @else {
  @for (message of historyMessages(); track message.id) {
    <div class="message-block">
      <div class="message-meta" [class.user-meta]="message.role === 'user'">
        @if (message.role === 'model') {
          <app-parent-ai-assistant-meta-row />
        } @else {
          <app-parent-ai-user-meta-row
            [displayName]="userDisplayName()"
            [avatarUrl]="userAvatarUrl()"
            [initialsSource]="userInitialsSource()"
          />
        }
      </div>
      <div class="message-group">
        <div class="message-bubble" [class.user-message]="message.role === 'user'">
          <div class="message-text">
            <span [innerHTML]="message.content | formatMessage"></span>
          </div>
        </div>
      </div>
    </div>
  }
  @if (streamingMessage() && streamingVisibleText()) {
    <div class="message-block">
      <div class="message-meta">
        <app-parent-ai-assistant-meta-row />
      </div>
      <div class="message-group">
        <div class="message-bubble">
          <div class="message-text message-text--streaming">
            <span [innerHTML]="streamingVisibleText() | formatMessage"></span><span class="stream-cursor" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </div>
  }
  @if (sendErrorMessage(); as errMsg) {
    <ng-container *ngTemplateOutlet="assistantBubble; context: { bubbleClass: 'message-bubble-error', bodyTemplate: errorBubbleBody, bodyContext: { errMsg } }"></ng-container>
  }
  @if (showTypingIndicator()) {
    <ng-container *ngTemplateOutlet="assistantBubble; context: { bodyTemplate: typingBubbleBody }"></ng-container>
  }
}

<ng-template #assistantBubble let-bubbleClass="bubbleClass" let-bodyTemplate="bodyTemplate" let-bodyContext="bodyContext">
  <div class="message-block">
    <div class="message-meta">
      <app-parent-ai-assistant-meta-row />
    </div>
    <div class="message-group">
      <div class="message-bubble" [class.message-bubble-error]="bubbleClass === 'message-bubble-error'">
        @if (bodyTemplate; as body) {
          <ng-container *ngTemplateOutlet="body; context: bodyContext ?? {}"></ng-container>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errorBubbleBody let-errMsg="errMsg">
  <div class="message-text">{{ errMsg }}</div>
</ng-template>

<ng-template #typingBubbleBody>
  <div class="message-text">
    <div class="typing-indicator">
      <span></span><span></span><span></span>
    </div>
  </div>
</ng-template>
